import { render, staticRenderFns } from "./SubscriptionPlansList.vue?vue&type=template&id=afd586a0&"
import script from "./SubscriptionPlansList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports